import { PAGE_SUCCESS } from 'store/app/actions';

import { types } from './actions';

const initialState = {
  arePaymentTermsCreating: false,
  isPaymentTermsDrawerOpen: false,
  isSaving: false,
  paymentTerms: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case PAGE_SUCCESS:
      return {
        ...initialState,
      };
    case types.CREATE_PAYMENT_TERMS_ERROR:
      return {
        ...state,
        arePaymentTermsCreating: false,
      };
    case types.CREATE_PAYMENT_TERMS_SUCCESS:
      return {
        ...state,
        arePaymentTermsCreating: false,
        paymentTerms: state.paymentTerms.concat([payload.paymentTerm]),
        isPaymentTermsDrawerOpen: false,
      };
    case types.CREATE_PAYMENT_TERMS_REQUEST:
      return {
        ...state,
        arePaymentTermsCreating: true,
      };
    case types.PAYMENT_TERMS_DRAWER_CLOSE:
      return {
        ...state,
        isPaymentTermsDrawerOpen: false,
      };
    case types.PAYMENT_TERMS_DRAWER_OPEN:
      return {
        ...state,
        isPaymentTermsDrawerOpen: true,
      };
    case types.SAVE_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    case types.SAVE_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case types.SAVE_SUCCESS:
      return {
        ...state,
        isSaving: false,
      };
    case types.GET_PAYMENT_TERMS:
      return {
        ...state,
        paymentTerms: payload,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.drawers.accountDrawer;

export const getArePaymentTermsCreating = (state) =>
  getScope(state).arePaymentTermsCreating;

export const getIsPaymentTermsDrawerOpen = (state) =>
  getScope(state).isPaymentTermsDrawerOpen;

export const getIsSaving = (state) => getScope(state).isSaving;

export const getPaymentTerms = (state) => getScope(state).paymentTerms;
